module.exports = __webpack_public_path__ + "images/init/not-arranged-empty@2x-907e6178d8daad8e15e61285bcf73522.png";